export enum TaskVoiceCardAction {
  activeCall = 'activeCall',
  endedCall = 'endedCall',
  missedCall = 'missedCall',
  heldCall = 'heldCall',
}

export const getTaskVoiceCardAction = ({
  isInbound,
  isTransferring,
  isWrapUp,
  isHeld,
  isMissed,
  isOffered,
  isConnecting,
  isSelfTransfer,
}: {
  isInbound: boolean;
  isTransferring: boolean;
  isWrapUp: boolean;
  isHeld: boolean;
  isMissed: boolean;
  isConnecting: boolean;
  isOffered: boolean;
  isSelfTransfer: boolean;
}): TaskVoiceCardAction | null => {
  if (isHeld) {
    return TaskVoiceCardAction.heldCall;
  }
  if (isMissed) {
    return TaskVoiceCardAction.missedCall;
  }
  if (isSelfTransfer) {
    return TaskVoiceCardAction.endedCall;
  }
  if (isWrapUp && !isTransferring) {
    return TaskVoiceCardAction.endedCall;
  }
  if (isInbound && (isOffered || isConnecting)) {
    return TaskVoiceCardAction.activeCall;
  }
  return null;
};
